import { TStatusConf } from '../status-header.component';

export const TNA_UPDATES_STATUS_BAR_CONF: TStatusConf = [
  {
    status: 'OVERDUE',
    displayName: 'Overdue',
    mobile: {
      active: {
        color: '#900000',
        backgroundColor: '#F7CEC6',
        border: '4px solid #900000',
      },
      default: {
        color: '#900000',
        backgroundColor: '#F7CEC6',
        border: '4px solid #F7CEC6',
      },
      colSize: 4,
    },
    web: {
      active: {
        color: '#900000',
        backgroundColor: '#F7CEC6',
        border: '4px solid #F7CEC6',
        'border-bottom': '4px solid #900000',
      },
      default: {
        color: '#900000',
        backgroundColor: '#F7CEC6',
        border: '4px solid #F7CEC6',
      },
    },
  },
  {
    status: 'TODAY',
    displayName: 'Today',
    mobile: {
      active: {
        color: '#C87304',
        backgroundColor: '#FFD6AD',
        border: '4px solid #C87304',
      },
      default: {
        color: '#C87304',
        backgroundColor: '#FFD6AD',
        border: '4px solid #FFD6AD',
      },
      colSize: 4,
    },
    web: {
      active: {
        color: '#C87304',
        backgroundColor: '#FFD6AD',
        border: '4px solid #FFD6AD',
        'border-bottom': '4px solid #C87304',
      },
      default: {
        color: '#C87304',
        backgroundColor: '#FFD6AD',
        border: '4px solid #FFD6AD',
      },
    },
  },
  {
    status: 'UPCOMING',
    displayName: 'Upcoming',
    mobile: {
      active: {
        color: '#007D35',
        backgroundColor: '#9DDFB9',
        border: '4px solid #007D35',
      },
      default: {
        color: '#007D35',
        backgroundColor: '#9DDFB9',
        border: '4px solid #9DDFB9',
      },
      colSize: 4,
    },
    web: {
      active: {
        color: '#007D35',
        backgroundColor: '#9DDFB9',
        border: '4px solid #9DDFB9',
        'border-bottom': '4px solid #007D35',
      },
      default: {
        color: '#007D35',
        backgroundColor: '#9DDFB9',
        border: '4px solid #9DDFB9',
      },
    },
  },
];

export const TNA_APPROVALS_STATUS_BAR_CONF: TStatusConf = [
  {
    status: 'REQUESTS',
    displayName: 'My Requests',
    mobile: {
      active: {
        color: '#ffffff',
        backgroundColor: 'var(--primary-color-2)',
        border: '1px solid #282C3F',
        'text-align': 'center',
      },
      default: {
        color: '#282C3F',
        backgroundColor: '#ffffff',
        border: '1px solid #282C3F',
        'text-align': 'center',
      },
      colSize: 6,
    },
    web: {
      active: {
        color: '#900000',
        backgroundColor: '#F7CEC6',
        border: '4px solid #F7CEC6',
        'border-bottom': '4px solid #900000',
      },
      default: {
        color: '#900000',
        backgroundColor: '#F7CEC6',
        border: '4px solid #F7CEC6',
      },
    },
  },
  {
    status: 'PENDING',
    displayName: 'Pending Approval',
    mobile: {
      active: {
        color: '#ffffff',
        backgroundColor: 'var(--primary-color-2)',
        border: '1px solid #282C3F',
        'text-align': 'center',
      },
      default: {
        color: '#282C3F',
        backgroundColor: '#ffffff',
        border: '1px solid #282C3F',
        'text-align': 'center',
      },
      colSize: 6,
    },
    web: {
      active: {
        color: '#C87304',
        backgroundColor: '#FFD6AD',
        border: '4px solid #FFD6AD',
        'border-bottom': '4px solid #C87304',
      },
      default: {
        color: '#C87304',
        backgroundColor: '#FFD6AD',
        border: '4px solid #FFD6AD',
      },
    },
  },
];

export const PROCESS_MAPPING_CONTAINER_HEADER_CONF: TStatusConf = [
  {
    status: 'ALL_PROCESSES',
    displayName: 'ALL PROCESSES',
    web: {
      active: {
        color: '#0033EB',
        backgroundColor: '#C4D0FA',
        border: '4px solid #C4D0FA',
        'border-bottom': '4px solid #0033EB',
      },
      default: {
        color: '#0033EB',
        backgroundColor: '#f8f8f8',
        border: '4px solid #f8f8f8',
      },
    },
  },
  {
    status: 'PROCESS_MAPS',
    displayName: 'PROCESS MAPS',
    web: {
      active: {
        color: '#0033EB',
        backgroundColor: '#C4D0FA',
        border: '4px solid #C4D0FA',
        'border-bottom': '4px solid #0033EB',
      },
      default: {
        color: '#0033EB',
        backgroundColor: '#f8f8f8',
        border: '4px solid #f8f8f8',
      },
    },
  },
  {
    status: 'FACTORY_CREATION',
    displayName: 'FACTORY CREATION',
    web: {
      active: {
        color: '#0033EB',
        backgroundColor: '#C4D0FA',
        border: '4px solid #C4D0FA',
        'border-bottom': '4px solid #0033EB',
      },
      default: {
        color: '#0033EB',
        backgroundColor: '#f8f8f8',
        border: '4px solid #f8f8f8',
      },
    },
  },
];
